import type { PropsWithChildren } from 'react'
import { useContext } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import AIGlowHighlightContext from 'contexts/aiGlowHighlightContext'
import AIGlowRing from './AIGlowRing'

/*
 * The radius exists purely for the ring to inherit — the shell itself paints nothing.
 * The padding is deliberately unconditional (not gated on the glow) so the summary's
 * footprint is identical before, during, and after the glow: the ring appearing must
 * never cause a layout shift.
 */
const Shell = styled.div`
  position: relative;
  width: fit-content;
  max-width: 100%;
  padding: ${rem(6)} ${rem(8)};
  border-radius: ${rem(8)};
`

interface Props {
  className?: string
  'data-testid'?: string
  /** Test id for the ring itself, which only exists while the glow is active */
  glowTestId?: string
}

function AIGlowSummaryShell({ className, 'data-testid': dataTestId, glowTestId, children }: PropsWithChildren<Props>) {
  const isGlowing = useContext(AIGlowHighlightContext)

  return (
    <Shell className={className} data-testid={dataTestId}>
      {isGlowing && <AIGlowRing data-testid={glowTestId} />}
      {children}
    </Shell>
  )
}

export default AIGlowSummaryShell
